// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const industryInDescriptionOneMax = 2000;

export const industryInNameMax = 120;

export const IndustryIn = zod.object({
  "description": zod.union([zod.string().max(industryInDescriptionOneMax),zod.null()]).optional(),
  "name": zod.string().min(1).max(industryInNameMax)
});

export type IndustryIn = zod.input<typeof IndustryIn>;
export type IndustryInOutput = zod.output<typeof IndustryIn>;
